export default __webpack_public_path__ + "static/media/casaduana_calendario.22f7ee84.svg";